<template>
  <v-form ref="form" lazy-validation class="pl-12 pr-12">
    <v-layout row wrap>
      <v-flex md12>
        <div class="mb-12 title font-weight-regular">Contato do Hospital</div>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Nome</div>
      </v-flex>
      <v-flex md8>
        <v-text-field
          outlined
          clearable
          placeholder="Nome do Contato"
          v-model="name"
          :rules="nameRules"
          dense
          type="text"
          color="teal accent-3"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Função</div>
      </v-flex>
      <v-flex md8>
        <v-text-field
          outlined
          clearable
          placeholder="Função"
          v-model="occupation"
          :rules="occupationRules"
          dense
          type="text"
          color="teal accent-3"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">E-mail</div>
      </v-flex>
      <v-flex md8>
        <v-text-field
          outlined
          clearable
          placeholder="E-mail"
          v-model="email"
          :rules="emailRules"
          dense
          type="text"
          color="teal accent-3"
        ></v-text-field>
      </v-flex>
      <v-flex md4>
        <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Telefone</div>
      </v-flex>
      <v-flex md8>
        <v-text-field
          outlined
          clearable
          v-mask="mask.phone"
          placeholder="Telefone"
          v-model="phone"
          :rules="phoneRules"
          dense
          type="text"
          color="teal accent-3"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
    name:'FormContactInfo',
    directives: { mask },
    props:['contact'],
    data:()=>({
        name:undefined,
        occupation:undefined,
        email:undefined,
        phone:undefined,
        mask:{
            phone:"(##) #####-####"
        },
        nameRules:[
            v=> !!v || 'Nome precisa ser preenchido!'
        ],
        occupationRules:[
            v=> !!v || 'Localização precisa ser preenchido!'
        ],
        emailRules:[
            v=> !!v || 'Localização precisa ser preenchido!',
            v=> (/^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i.test(v)) || 'Email Inválido!'
        ],
        phoneRules:[
           v => !!v || 'Telefone precisa ser preenchido!',
           v => (v && /\(\d{2}\)\s\d{4,5}-?\d{4}/g.test(v)) || 'Telefone Inválido!',
        ]
    }),
    created () {
      if(this.contact){
          this.name = this.contact.name
          this.occupation = this.contact.occupation
          this.email = this.contact.email
          this.phone = this.contact.phone
      }
    },

    methods:{

      setContactInfo(){

        if(this.$refs.form.validate()){
          return {
            name:this.name,
            occupation:this.occupation,
            email : this.email,
            phone:this.phone
          }
        }
        return false 
      }
    },
    
    computed:{

      selectedHospitalContact(){

        let selected = this.$store.getters.selectedHospital
        return selected  
      }
    }
};
</script>

<style>
</style>